function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:currentColor; stroke:none}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_138",
  d: "M20.079 6.962c4.272 0 4.778.016 6.465.093a8.856 8.856 0 0 1 2.971.551 5.3 5.3 0 0 1 3.037 3.037 8.855 8.855 0 0 1 .551 2.971c.077 1.687.093 2.193.093 6.465s-.016 4.778-.093 6.465a8.856 8.856 0 0 1-.551 2.971 5.3 5.3 0 0 1-3.037 3.037 8.856 8.856 0 0 1-2.971.551c-1.687.077-2.193.093-6.465.093s-4.778-.016-6.465-.093a8.856 8.856 0 0 1-2.971-.551 5.3 5.3 0 0 1-3.037-3.037 8.856 8.856 0 0 1-.551-2.971c-.077-1.687-.093-2.193-.093-6.465s.016-4.778.093-6.465a8.855 8.855 0 0 1 .551-2.971 5.3 5.3 0 0 1 3.037-3.037 8.856 8.856 0 0 1 2.971-.551c1.687-.077 2.193-.093 6.465-.093m0-2.883c-4.345 0-4.89.018-6.6.1a11.744 11.744 0 0 0-3.879.74A8.182 8.182 0 0 0 4.919 9.6a11.744 11.744 0 0 0-.744 3.884c-.078 1.706-.1 2.251-.1 6.6s.018 4.89.1 6.6a11.744 11.744 0 0 0 .744 3.884A8.182 8.182 0 0 0 9.6 35.239a11.744 11.744 0 0 0 3.884.744c1.707.078 2.251.1 6.6.1s4.89-.018 6.6-.1a11.744 11.744 0 0 0 3.884-.744 8.182 8.182 0 0 0 4.679-4.679 11.744 11.744 0 0 0 .744-3.884c.078-1.706.1-2.251.1-6.6s-.018-4.89-.1-6.6a11.744 11.744 0 0 0-.752-3.876 8.182 8.182 0 0 0-4.679-4.681 11.744 11.744 0 0 0-3.884-.744c-1.707-.078-2.251-.1-6.6-.1z",
  className: "cls-1",
  transform: "translate(-4.079 -4.079)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_139",
  d: "M135.908 126.635a9.273 9.273 0 1 0 9.273 9.273 9.273 9.273 0 0 0-9.273-9.273zm0 15.292a6.019 6.019 0 1 1 6.019-6.019 6.019 6.019 0 0 1-6.019 6.019z",
  className: "cls-1",
  transform: "translate(-119.908 -119.908)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_8",
  cx: 1.659,
  cy: 1.659,
  r: 1.659,
  className: "cls-1",
  transform: "translate(23.04 5.642)"
});

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "instagram",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.23fa97ea.svg";
export { ForwardRef as ReactComponent };